export const COOKIE_POLICY = "COOKIE_POLICY";

export const getCookiePolicy = (data) => {
    return {
        type: COOKIE_POLICY,
        payload: data
    }
}